<template>
  <div class="page-content">
    <!-- <img width="1920" height=" 260" src="@/assets/images/page-1_img001.jpg" alt="right"> -->   

    <section class="well well-md well--inset-5 text-md-left">
      <products :products-data="productsData" :products-category="productsCategory" :products-brand="productsBrand"></products>
    </section>    

    <checkout-area class="main-wrapper" v-if="hasProduct" :showModal="showCheckoutModal" :cart="cart" :tax="tax" :cart-sub-total="cartSubTotal" :cart-total="cartTotal" />
  </div>
</template>

<script>
  import ProductList from './ProductList';
  import Checkout from './Checkout';

  import {bus} from '../main';

  import common from '../common';
  import axios from 'axios';

  var {api} = common;

  export default {
    name: "Product",
    components: {
      products: ProductList,
      'checkout-area': Checkout,
    },

    data: function() {
      return {
        cart: [],
        tax: 12,
        cartSubTotal: 0,
        cartTotal: 0,
        hasProduct: false,
        productsData: [],
        productsCategory: [],
        productsBrand: [],
        showCheckoutModal: false,
      }
    },

    created() {
      bus.$on('updateProdPage', (data) => {
        for(var key in data) {
          if(data.hasOwnProperty(key)) this[key] = data[key];
        }
      });
      bus.$on('openCheckoutModal', () => {
        this.showCheckoutModal = true;
      });
      bus.$on('checkoutModalHide', () => {
        this.showCheckoutModal = false;
      });
    },

    mounted() {
      let cartData = localStorage && localStorage.getItem('cartData') ? JSON.parse(localStorage.cartData) : {cart: []};
      for(var key in cartData) {
        if(cartData.hasOwnProperty(key)) this[key] = cartData[key];
      }
      axios.get(api + 'admin/allproduct').then((resp) => {
        resp.data.map(item => {
          let images = item.image.split(', ');
          if(images.length > 1) {
            item.images = images;
            item.image = images[0];
          }
          return item;
        });
        this.productsData = resp.data;
      });
      axios.get(api + 'admin/allcategory').then((resp) => {
        this.productsCategory = resp.data;
      });
      axios.get(api + 'admin/allbrand').then((resp) => {
        this.productsBrand = resp.data;
      });
    },
  }
</script>


<style scoped>
h1 {
  display: block;
  margin: 0 auto;
}
</style>